export const ALPHANUMERIC_UTF8_REGEX = /^[a-zA-ZáàâäãåçéèêëíìîïñóòôöõúùûüýÿÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸñÑ0-9\s]+$/i;
export const ALPHANUMERIC_UTF8_PARAGRAPH_REGEX = /^[,.!¡;:a-zA-ZáàâäãåçéèêëíìîïñóòôöõúùûüýÿÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸñÑ0-9\s]+$/i;
export const PARAGRAPH_UTF8_REGEX = /^[,.!¡;:\[\]\/_a-zA-ZáàâäãåçéèêëíìîïñóòôöõúùûüýÿÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸñÑ0-9\s]+$/i;
export const ALPHA_NO_SPACE_REGEX = /^[a-zA-Z]+$/;
export const FIELD_VARIABLE_REGEX = /\[[^\]]*\]/g;
export const NUMBERS_REGEX = /^-?(0|[1-9]\d*)$/;